export default __webpack_public_path__ + "static/media/Shawabti.a3cb50f7.jpg";